module.exports = __webpack_public_path__ + "static/media/broken.c71cc862.jpg";